import { render, staticRenderFns } from "./CurrencyButton.vue?vue&type=template&id=1a5869b6&"
import script from "./CurrencyButton.vue?vue&type=script&lang=js&"
export * from "./CurrencyButton.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Flag: require('/opt/build/repo/storefront/components/legacy/global/flag.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default})
